module.exports = __webpack_public_path__ + "static/img/refresh-icon.c640cfba.svg";